export default __webpack_public_path__ + "static/media/lottery-random-terrabots.16b72ab7.png";